import { CsvButton } from '@components/Buttons/CsvButton';
import { LinkText } from '@components/LinkText';
import { Pagination } from '@components/Table/Pagination';
import { TableLinearLoading } from '@components/Table/TableLinearLoading';
import { TableNoResult } from '@components/Table/TableNoResult';
import { TableSortCell } from '@components/Table/TableSortCell';
import { TableSortRow } from '@components/Table/TableSortRow';
import { TableWrapper } from '@components/Table/TableWrapper';
import { IData } from '@hooks/useData';
import useFormatter from '@hooks/useFormatter';
import { TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import { IContratoCliente, useOrigemCancelamentoColor } from '@model/ContratoCliente';
import { IRelatorioCancelamentoFilter } from '@services/Relatorios/CancelamentoService';
import React from 'react';

export type RelatorioCancelamentoTableProps = {
    data: IData<IContratoCliente, IRelatorioCancelamentoFilter>
    isLoading: boolean
    onCsvButtonClick: VoidFunction
}

export function RelatorioCancelamentoTable ({ data, isLoading, onCsvButtonClick }: RelatorioCancelamentoTableProps) {
    const formatter = useFormatter();
    const origemCancelamentoColor = useOrigemCancelamentoColor();

    return (
        <React.Fragment>
            <TableWrapper>
                <TableLinearLoading isLoading={isLoading} />
                <TableNoResult itemCount={data.itemsCount}>
                    <TableHead>
                        <Pagination pagination={data.pagination}>
                            <CsvButton onClick={onCsvButtonClick} disabled={isLoading} />
                        </Pagination>

                        <TableSortRow sort={data.sort}>
                            <TableSortCell fieldName="contratoClienteId">ID</TableSortCell>
                            <TableSortCell fieldName="clienteNome">Cliente</TableSortCell>
                            <TableSortCell fieldName="linhaNumero">Nº da Linha</TableSortCell>
                            <TableSortCell fieldName="clienteRemetente">Remetente</TableSortCell>
                            <TableSortCell fieldName="valorPlano">Vlr. Plano</TableSortCell>
                            <TableSortCell fieldName="usuarioCancelamentoNome">Operador</TableSortCell>
                            <TableSortCell fieldName="origemCancelamento">Origem</TableSortCell>
                            <TableSortCell fieldName="dataCancelamento">Data</TableSortCell>
                            <TableSortCell fieldName="justificativaCancelamento">Justificativa</TableSortCell>
                        </TableSortRow>
                    </TableHead>
                    
                    <TableBody>
                        {
                            data.items.map((contratoCliente, index) => {
                                return (
                                    <TableRow key={index}>
                                        <TableCell><strong>{contratoCliente.contratoClienteId}</strong></TableCell>
                                        <TableCell><LinkText text={contratoCliente.clienteNome} to={`/cliente/${contratoCliente.clienteId}`} /></TableCell>
                                        <TableCell>{formatter.toCelular(contratoCliente.linhaNumero)}</TableCell>
                                        <TableCell>{formatter.toCelular(contratoCliente.clienteRemetente)}</TableCell>
                                        <TableCell>{formatter.toFloat(contratoCliente.valorPlano)}</TableCell>
                                        <TableCell>{contratoCliente.usuarioCancelamentoNome}</TableCell>
                                        <TableCell className={origemCancelamentoColor[contratoCliente.origemCancelamento]}>{contratoCliente.origemCancelamentoDescription}</TableCell>
                                        <TableCell>{formatter.toDate(contratoCliente.dataCancelamento)}</TableCell>
                                        <TableCell>{contratoCliente.justificativaCancelamento}</TableCell>
                                    </TableRow>
                                )
                            })
                        }

                        <Pagination pagination={data.pagination}>
                            <CsvButton onClick={onCsvButtonClick} disabled={isLoading} />
                        </Pagination>
                    </TableBody>
                </TableNoResult>
            </TableWrapper>
        </React.Fragment>
    )
}